import { render, staticRenderFns } from "./Exercices.vue?vue&type=template&id=c036cc62&scoped=true&"
import script from "./Exercices.js?vue&type=script&lang=js&"
export * from "./Exercices.js?vue&type=script&lang=js&"
import style0 from "./Exercices.vue?vue&type=style&index=0&id=c036cc62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c036cc62",
  null
  
)

export default component.exports